import { useContext, useState } from "react"
import { Context } from "../context/AuthProvider"
import buildForm from './buildForm'
import {GlobalMessageContext} from "../context/GlobalMessage";
import useQuery from "../routes/helper/useQueryHooks";
import parseErrorClient from "../utils/parseErrorClient";

const LoginHooks = () => {
    const [ loading, setLoading] = useState(false)
    const { handleLogin : handleLoginProvider } = useContext(Context)
    const { setNotification } = useContext(GlobalMessageContext)
    const target = useQuery().get("target")
    const handleLogin = async (event) => {
        event.preventDefault()

       try {
        setLoading(true)
        if (!loading) await handleLoginProvider(buildForm(event.target), target)
       } catch (error) {
           setNotification(parseErrorClient(error, setLoading))
       }
    }

    return {
        handleLogin,
        loading
    }
}

export default LoginHooks